import { FormGroup, Input, Label } from "reactstrap";
import { useThemeContext } from "../../Context/ThemeContext";
import { getDarkInput } from "../../Utils/otherFunctions";

const FileInputField = ({ state, label, name, onChange, className, size }) => {
  const { themeContext } = useThemeContext();

  return (
    <FormGroup className={className}>
      {label && (
        <Label for={name} className={"bg-transparent"}>
          {label}
        </Label>
      )}
      <Input
        className={getDarkInput(themeContext)}
        type="file"
        id={name}
        name={name}
        onChange={onChange}
        size={size}
      />
    </FormGroup>
  );
};

export default FileInputField;
